import { httpGet } from "../connection";
import { GetEvidenceStatusFn } from "./evidence-status.types";
export * from "./evidence-status.types";

const getEvidenceStatus: GetEvidenceStatusFn = (options = {}) => {
  return httpGet("/evidence-status", options);
};

const EvidenceStatusAPI = {
  getEvidenceStatus,
};

export default EvidenceStatusAPI;
